<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Itens do {{acompanhamento.lote}}</span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table :headers="colunas" :items="itensGrupo"
                      :total-items="itensGrupo.length"
                      :loading="false" hide-actions
                      no-data-text="Não há itens do grupo disponíveis"
                      class="az-table-list px-4 pt-2 pb-3">
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{ props.item.sequencia || '-'}}
              </td>
              <td>
                {{ props.item.descricao || '-'}}
              </td>
              <td>
                {{ props.item.unidade || '-'}}
              </td>
              <td>
                <formatador-moeda
                    v-if="possuiQuantidade(props.item.quantidade)"
                    :valor="Number(props.item.quantidade)"
                    :casas-decimais="casasDecimaisQuantidade"
                />
                <span v-else>-</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import FormatadorMoeda from '@/views/components/FormatadorMoeda.vue'
import {normalizarCasasDecimais} from '@/core/utils/CasasDecimaisUtils'

export default {
    name: 'ModalVerItensGrupo',
    components: {
        FormatadorMoeda
    },
    props: {
        maxWidth: {
            type: String,
            default: '800'
        },
    },
    data() {
        return {
            exibir: false,
            acompanhamento: {},
            itensGrupo: [],
        }
    },
    computed: {
        casasDecimaisQuantidade() {
            const licitacao = (this.$store && this.$store.state && this.$store.state.licitacao) || {}
            return normalizarCasasDecimais(licitacao.casasDecimaisQuantidade)
        },
        colunas() {
            return [
                {
                    value: 'sequencia',
                    text: 'Item',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'descricao',
                    text: 'Descrição',
                    align: 'left',
                    width: '40%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'unidade',
                    text: 'Unidade',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'quantidade',
                    text: 'Quantidade',
                    align: 'left',
                    width: '15%',
                    sortable: false,
                    class: 'primary--text'
                },
            ]
        }
    },
    methods: {
        possuiQuantidade(quantidade) {
            return quantidade !== null && quantidade !== undefined && quantidade !== '' && !Number.isNaN(Number(quantidade))
        },
        async open({ acompanhamento } = {}) {
            this.acompanhamento = acompanhamento || {}
            this.itensGrupo = (acompanhamento && acompanhamento.itens) ? acompanhamento.itens : []
            this.exibir = true
        },
        fecharModal() {
            this.exibir = false
            this.acompanhamento = {}
            this.itensGrupo = []
        }
    }
}

</script>